import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';


const GuestGuard = props => {
  const { children, fallback } = props
  const auth = useAuth()
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
      if (auth.user) {
        navigate('/', { replace: true })
      }
    }, [location.pathname, auth]
  )
  
  if (auth.loading || (!auth.loading && auth.user !== null)) {
    return fallback
  }

  return <>{children}</>
}

export default GuestGuard
